import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save, Mail } from "lucide-react";
import { adminApi } from "@/lib/lnlApi";
import { errMsg, inputCls } from "./shared";

export default function StatusEmailsTab({ meta }) {
    const [map, setMap] = useState(null);
    const [templates, setTemplates] = useState([]);
    const ro = !meta.can.settings;
    useEffect(() => {
        adminApi.get("/auto-responses/settings").then((r) => setMap(r.data.status_templates || {})).catch((e) => toast.error(errMsg(e)));
        adminApi.get("/auto-responses/templates").then((r) => setTemplates(r.data.filter((t) => !t.archived))).catch(() => {});
    }, []);
    if (!map) return <div className="text-sm text-lnl-gray">Loading…</div>;
    async function save() {
        try { const { data } = await adminApi.put("/auto-responses/settings", { status_templates: map }); setMap(data.status_templates || {}); toast.success("Status update emails saved"); }
        catch (e) { toast.error(errMsg(e)); }
    }
    const sorted = [...templates].sort((a, b) => (b.inquiry_type === meta.status_type) - (a.inquiry_type === meta.status_type));
    return (
        <div data-testid="status-emails-tab">
            <p className="text-sm text-lnl-gray mb-4 max-w-3xl">When staff change an application’s status (with “Notify applicant” ticked), the template chosen below is emailed to the applicant. Use <code>{"{{application_status}}"}</code> and <code>{"{{status_note}}"}</code> (the note typed with the change) in any template.</p>
            <div className="lnl-card divide-y divide-lnl-border">
                {meta.app_statuses.map((st) => {
                    const t = templates.find((x) => x.id === map[st]);
                    return (
                        <div key={st} className="p-4 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4" data-testid={`status-row-${st.replace(/\s+/g, "-").toLowerCase()}`}>
                            <div className="sm:w-48 font-heading font-semibold text-lnl-charcoal flex items-center gap-2"><Mail className={`h-4 w-4 ${map[st] ? "text-lnl-green" : "text-gray-300"}`} />{st}</div>
                            <select disabled={ro} value={map[st] || ""} onChange={(e) => setMap({ ...map, [st]: e.target.value })} className={`${inputCls} sm:max-w-md`} data-testid={`status-template-${st.replace(/\s+/g, "-").toLowerCase()}`}>
                                <option value="">No email for this status</option>
                                {sorted.map((x) => <option key={x.id} value={x.id}>{x.template_name}{x.is_active ? "" : " (inactive)"}</option>)}
                            </select>
                            {t && !t.is_active && <span className="text-[11px] text-amber-700">Template is inactive — no email will be sent.</span>}
                        </div>
                    );
                })}
            </div>
            {!ro && <div className="mt-4 flex justify-end"><button onClick={save} className="lnl-btn-primary" data-testid="status-emails-save"><Save className="h-4 w-4" /> Save Status Emails</button></div>}
        </div>
    );
}
